import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import React from 'react';
import {FixedSizeList} from 'react-window';

import {ConfigConstant} from '../../constants/config';

const CustomValueList = ({
  items,
  onClick,
  showMenuItemSelectBox,
  currentFilter,
  showSelectedDisabled,
  virtualLoadWidth,
  virtualLoadHeight,
}) => {
  const showDisabled = (item) => {
    if (showSelectedDisabled === true) {
      return (
        (currentFilter?.type === 'date' && currentFilter?.displayValue === item?.code) ||
        currentFilter?.value === item?.code
      );
    } else {
      return false;
    }
  };

  const showChecked = (item) => {
    if (currentFilter?.id === 'Date') {
      return currentFilter?.displayValue === item?.code;
    } else if (currentFilter?.selectType === ConfigConstant.FILTER_SELECT_TYPE.MULTIPLE) {
      return currentFilter?.value?.includes(item?.code);
    } else {
      return Array.isArray(currentFilter?.value)
        ? currentFilter?.value?.includes(item?.code)
        : currentFilter?.value === item?.code;
    }
  };

  const checkedItems = items.filter((item) => showChecked(item));
  const uncheckedItems = items.filter((item) => !showChecked(item));

  const mergedItems = [...checkedItems, ...uncheckedItems];

  return (
    <FixedSizeList
      height={virtualLoadHeight || 1000}
      itemCount={mergedItems?.length || 0}
      itemSize={40}
      width={virtualLoadWidth || 350}
    >
      {({index, style}) => (
        <MenuItem
          key={index}
          onClick={() => onClick(mergedItems[index])}
          sx={{width: '100%', ...style}}
          disabled={showDisabled(mergedItems[index])}
        >
          {currentFilter?.selectType === ConfigConstant.FILTER_SELECT_TYPE.MULTIPLE && (
            <Checkbox checked={showChecked(mergedItems[index])} />
          )}
          {showMenuItemSelectBox && currentFilter?.selectType === ConfigConstant.FILTER_SELECT_TYPE.SINGLE && (
            <Radio checked={showChecked(mergedItems[index])} />
          )}
          {mergedItems[index].label}
        </MenuItem>
      )}
    </FixedSizeList>
  );
};

export default CustomValueList;
